module.exports = __webpack_public_path__ + "img/learn-icon-add-clover.acffbcee.svg";